/**
 *
 * @param key           [required] field name
 * @param type          [required] field type text, email, array-items, array-custom
 * @param value         [required] field value
 * @param required      [optional] indicates if the field is mandatory
 * @param onChange      [required] callback on change value
 * @param fields        [optional] internal validation fields of the object
 * @param arrayRequired
 * @returns {{init: boolean, onChange: onChange, type: *, error: boolean, value: unknown, required: *}}
 * @constructor
 */
function FieldValidation(key, type, value, required, onChange, fields, arrayRequired) {
    const errorField = (_type, v, _required, maxIndex) => {
        let validItems = true;
        switch (_type) {
            // has error in strings
            case 'text':
                if (v) {
                    v = v.trim();
                }
                return !!(!v);

            // has error in emails
            case 'email':
                if (!_required && !(!!v)) {
                    return false;
                }
                const re = /^\S+@\S+\.\S+$/;
                return !re.test(String(v).toLowerCase());

            // has error in array items
            case 'array-items':
                if(!v || v.length === 0){
                    return true;
                }
                validItems = true;
                for (let i = 0; i < v.length; i++) {
                    if (v[i] && (typeof v[i].valid != 'undefined' && !v[i].valid)) {
                        validItems = false;
                        break;
                    }
                    if (!!maxIndex && (i + 1) >= maxIndex && maxIndex !== -1) {
                        break
                    }
                }
                return !validItems;
            case 'array-phones':
                if(!v || v.length === 0){
                    return _required;
                }
                validItems = true;
                for (let i = 0; i < v.length; i++) {
                    const hasValid = v[i].hasOwnProperty("valid");
                    const hasRequired = v[i].hasOwnProperty("required")? v[i].required : false;
                    const required = ((i + 1) >= maxIndex && maxIndex !== -1 && _required) || hasRequired;
                    if ((required && !v[i].number) || (v[i].number && hasValid && !v[i].valid)) {
                         validItems = false;
                        break;
                    }
                }
                return !validItems;
            // has error in date
            case 'date':
                return !!v && typeof v !== 'number' || !v;

            default:
                return false;
        }
    }

    const hasError = (v) => {
        switch (type) {
            case 'text':
            case 'email':
                return errorField(type, v, field.getRequired());
            case 'array-phones':
            case 'array-items':
                return errorField(type, v, field.getRequired(), arrayRequired);
            case 'array-custom':
                let validContacts = true;
                if(!v || v.length === 0){
                    return field.getRequired();
                }
                for (let i = 0; i <= v.length; i++) {
                    let item = v[i];
                    if (item) {
                        // valid fields
                        if (fields) {
                            Object.keys(fields).map(function (key) {
                                const field = fields[key];
                                let _required;
                                if (typeof field.required === 'function') {
                                    _required = field.required(item);
                                } else {
                                    _required = field.required;
                                }
                                if (key === 'phones') {
                                    if (errorField(field.type, item[key], _required, field.arrayRequired)) {
                                        validContacts = false;
                                    }
                                } else {
                                    if (_required) {
                                        if (item.hasOwnProperty(key)) {
                                            if (errorField(field.type, item[key], _required, field.arrayRequired)) {
                                                validContacts = false;
                                            }
                                        } else {
                                            validContacts = false;
                                        }
                                    }
                                }
                            });
                        }
                        if (!validContacts) {
                            break
                        }
                    }
                    if ((i + 1) >= arrayRequired && arrayRequired !== -1) {
                        break;
                    }
                }
                return !validContacts;

            case 'date':
                return errorField(type, v, field.getRequired());

            default:
                return false;
        }
    };

    const _onChange = (v) => {
        onChange(key, v, hasError(v));
    };

    const field = {
        parent: null,
        type: type,
        value: value,
        required: required,
        arrayRequired: arrayRequired,
        error: false,
        errorMessage: '',
        init: false,
        hasError: hasError,
        onChange: _onChange,
        getRequired: () => {
            return required;
        }
    };
    return field;
}

/**
 * Example fields { "field1": { type: "text", required: true }, "field2": { type: "array-items", required: true, arrayRequired: 1 } }
 *                { "field3": { type: "array-custom", required: true, arrayRequired: 1 } } } }
 * @param fields           [required] object fields
 * @param onFormChange     [optional]
 * @returns {{valid: boolean, data: {}}}
 * @constructor
 */
function FormValidation(fields, onFormChange) {
    const clearProperties = (v) => {
        let value = JSON.parse(JSON.stringify(v));
        if (Array.isArray(value)) {
            for (let i = 0; i <= value.length; i++) {
                let item = value[i];
                if (item && item.hasOwnProperty("valid")) {
                    delete item["valid"];
                }
                if (item && item.hasOwnProperty("required")) {
                    delete item["required"];
                }
                if (item && item.hasOwnProperty("phones")) {
                    item["phones"] = clearProperties(item["phones"]);
                }
            }
        } else {
            if (value && value.hasOwnProperty("valid")) {
                delete value["valid"];
            }
            if (value && value.hasOwnProperty("required")) {
                    delete value["required"];
                }
            if (value && value.hasOwnProperty("phones")) {
                value["phones"] = clearProperties(value["phones"]);
            }
        }
        return value;
    };

    const data = {
        valid: false,
        data: {},
        setValue: function (key, v) {
            this.data[key].onChange(v, this.data);
        }
    };

    const _onChange = (key, v, error) => {
        data.data[key].value = v;
        data.data[key].error = error;
        data.data[key].init = true;
        const valid = validForm();
        if (onFormChange) {
            onFormChange(key, clearProperties(v), data.data[key], valid);
        }
    };

    const validForm = () => {
        let valid = true;
        Object.keys(data.data).map(function (key) {
            const field = data.data[key];
            const c1 = field.value || field.getRequired();
            const c2 = field.hasError(field.value, data.data) || !field.init;
            if (field.type !== "boolean" && c1 && c2) {
                valid = false;
            }
        });
        return valid;
    };

    const init = () => {
        Object.keys(fields).map(function (key) {
            const field = fields[key];
            const required = field.required ? field.required : false;
            const _fields = field.fields ? field.fields : null;
            const _arrayRequired = field.arrayRequired ? field.arrayRequired : 0;
            data.data[key] = FieldValidation(key, field.type, field.value, required, _onChange, _fields, _arrayRequired);
            data.data[key].errorMessage = field.errorMessage? field.errorMessage : '';
            data.data[key].getRequired = () => {
                let _required;
                if (typeof required === 'function') {
                    _required = !!required(data.data)? required(data.data) : false;
                } else {
                    _required = required;
                }
                return _required;
            }
        });
    };

    init();

    return data;
}

export default FormValidation;
